module.exports = __webpack_public_path__ + "static/assets/7c13e5e2b63594a8ce1683b3f7585385.svg";